import { TBoxStructure } from 'components/EMManagement/EMManagementId/EasParamsBox/types';
import { TEmManagementByIdFullResponse } from 'redux/reducers/emManagement/types';
import { ETableStructureType } from 'ui/EasTable/types';
import { EEmEnums } from '../../../redux/reducers/emManagement/constants';

export const landedCostSettingsBoxStructure: TBoxStructure<TEmManagementByIdFullResponse> = {
	header: [],
	body: [
		{
			name: "Client's Timezone",
			selector: 'timezone',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.TIMEZONE_LIST,
			editable: true,
			show: true,
			description:
				'Determines how order sales dates are converted to UTC. Use this to ensure local transaction times align correctly with UTC-based fiscal reporting.',
		},
		{
			name: 'Weight Unit',
			selector: 'weightUnit',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.WEIGHT_UNIT,
			editable: true,
			show: true,
			description: 'Select weight unit exactly the same as used in the customers store.',
		},
		{
			name: 'Prices Inclusive VAT',
			selector: 'priceInclusiveVat',
			type: ETableStructureType.BOOLEAN,
			editable: true,
			show: true,
		},
		{
			name: 'Allow Post Sale Orders',
			selector: 'postSaleOrdersAllowed',
			type: ETableStructureType.BOOLEAN,
			editable: true,
			show: true,
		},
		{
			name: 'Customs Data to be Collected',
			selector: 'customsDataToBeCollected',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.CUSTOMS_DATA_STATUS,
			editable: true,
			show: true,
			description:
				'Select how customs duties to be calculated: Calculate only -  duties will be included into the order only. Calculate and collect - duties are included into the order and invoice, EAS handles duties. Influence only on landed cost.',
		},
		{
			name: 'Payment Currency',
			selector: 'paymentCurrencyId',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.SUPPORTED_CURRENCY,
			editable: true,
			show: true,
		},
		{
			name: 'Payment Mode',
			selector: 'paymentHandlingMode',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.PAYMENT_MODE,
			editable: true,
			show: true,
			description:
				'Select how taxes are paid. DIRECT means the customer handles tax payment; INDIRECT means taxes are included in the invoice and handled by EAS for the customer. UK VAT always paid by customers.',
		},
		{
			name: 'B2B Sales enabled',
			selector: 'b2bSales',
			type: ETableStructureType.BOOLEAN,
			editable: true,
			show: true,
			description:
				'Enable to process B2B orders through EAS and track them in the EM Dashboard. Otherwise, these orders are not handled.',
		},
		{
			name: 'EAS fee included into Landed cost',
			selector: 'easFeeIncludedInLandedCost',
			type: ETableStructureType.BOOLEAN,
			editable: true,
			show: true,
		},
		{
			name: 'Personal Term of payment (Days)',
			selector: 'personalTermOfPayment',
			type: ETableStructureType.NUMBER,
			editable: true,
			show: true,
		},
		{
			name: 'IOSS Sale Over Intrinsic Threshold behaviour',
			selector: 'iossSaleOverThreshold',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.IOSS_SALE_OVER_THRESHOLD_OPTION,
			editable: true,
			show: true,
			description:
				'Applicable only for full landed cost customers. When not Allowed  system will either reject such sale or request confirmation.',
		},
		{
			name: 'IOSS duties handling mode',
			selector: 'iossDutyMode',
			type: ETableStructureType.ARRAY_ID,
			enumName: EEmEnums.IOSS_DUTY_MODES,
			editable: true,
			show: true,
			description: (
				<div>
					Select how 3 EUR IOSS duty is calculated.
					<br />
					<b>Do not calculate:</b> No changes to landed cost. <br />
					<b>Calculate VAT only:</b> Only the VAT on the IOSS duty is added to the order. <br />
					<b>Calculate and include in order:</b> Both the IOSS duty and the VAT on it are calculated
					and added at checkout. <br />
					<b>Calculate and pay to EAS:</b> IOSS duty and VAT are calculated, and EAS handles the
					duty payment. The IOSS duty is included in the invoice.
				</div>
			),
		},
	],
	title: 'Landed Cost Settings',
};
